import { useFormik } from "formik"
import InputNumber from "global/InputNumber/InputNumber"
import Modal from "global/Modal/Modal"
import SimpleButton from "global/SimpleButton/SimpleButton"
import { userInputPrice } from "global/Validation/Validation"
import { useEffect, useState } from "react"
import SharePercentFooter from "../components/sahred-percent"
import { ConsumeColumns } from "../consumer-credit-details/column"
import { FinancialCalculation } from "../consumer-credit-details/type"
import { addEditUrls } from "services/api.enums"
import { getAPI } from "services/CRUDServices"

function UserPayment({ open, setOpen, submit, currentData }) {
  const [sharePercentInfo, setSharePercentInfo] =
    useState<FinancialCalculation>()
  const { values, setFieldValue, errors, touched, handleSubmit, resetForm } =
    useFormik({
      enableReinitialize: true,
      validationSchema: userInputPrice,
      initialValues: {
        usedCredit: sharePercentInfo?.totalPayable,
      },
      onSubmit: () => {
        submit({ ...currentData, pay: +values.usedCredit })
      },
    })

  useEffect(() => {
    !open && resetForm({})
  }, [open])

  useEffect(() => {
    if (!open) return

    getAPI(addEditUrls.fetchSharePercentageFromCredit + currentData.id).then(
      (res) => {
        setSharePercentInfo(res.data.payload)
      }
    )
  }, [open])

  return (
    <Modal visible={open} setVisible={setOpen} title=' '>
      <form onSubmit={handleSubmit}>
        <table className='w-full'>
          <SharePercentFooter
            sharePercentInfo={{
              ...sharePercentInfo,
              usedCredit: currentData.findAllByConsignmentPriceFromHub.useCredit,
            }}
            columnLength={ConsumeColumns.length}
          />
        </table>
        <InputNumber
          wrapperClassName='w-[25rem] mt-10'
          handleChange={setFieldValue}
          values={values.usedCredit}
          name='usedCredit'
          error={touched.usedCredit && errors.usedCredit}
          label='مبلغ (ریال)'
          important
        />
        <div className='btnForm'>
          <SimpleButton
            handelClick={() => setOpen({ ...open, inquirtAccount: false })}
            text='انصراف'
            className='text-tomato'
          />
          <SimpleButton
            type='submit'
            text='تایید و واریز'
            className='full-tomato-btn'
          />
        </div>
      </form>
    </Modal>
  )
}

export default UserPayment
